// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Chip from '@material-ui/core/Chip';
import type { MapSource } from '../../../../types';
import SourceItemMenu from './SourceItemMenu';

const useStyles = makeStyles(theme => ({
    card: {
        boxShadow: 'none',
        margin: 0
    },
    cardHeader: {
        paddingTop: 0,
        paddingBottom: 0
    },
    cardHeaderContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    cardHeaderAction: {
        marginTop: 0
    },
    cardHeaderTitle: theme.typography.subtitle1,
    chip: {
        backgroundColor: (props) => (props.active ? theme.palette.success.main : theme.palette.grey.A100),
        color: (props) => (props.active ? theme.palette.common.white : 'inherit')
    }
}));

export type Props = $ReadOnly<{
    sourceId: string,
    source: MapSource,
    active: boolean,

    onPreview: (sourceId: string) => void,
    onDelete: (sourceId: string) => void,
    onActivate: (sourceId: string) => void
}>;

function SourceItem({ sourceId, source, active, onPreview, onDelete, onActivate }: Props) {
    const classes = useStyles({active});

    return (
        <Card
            raised={false}
            classes={{ root: classes.card,  }}
        >
            <CardHeader
                classes={{ root: classes.cardHeader, content: classes.cardHeaderContent, title: classes.cardHeaderTitle, action: classes.cardHeaderAction }}
                title={source.name}
                subheader={active && (
                    <Chip className={classes.chip} size="small" label={(
                            <FormattedMessage
                                id="options.user.active"
                                defaultMessage="Active"
                            />
                        )}
                    />)
                }
                action={(
                    <SourceItemMenu
                        className={classes.menu}
                        sourceId={sourceId}
                        source={source}
                        onPreview={onPreview}
                        onDelete={onDelete}
                        onActivate={onActivate}
                    />
                )}
            />
            {/*<CardContent>*/}
            {/*    <List dense={true} disablePadding={true}>*/}
            {/*        <ListItem disableGutters={true}>*/}
            {/*            <ListItemIcon>*/}
            {/*                <FormattedMessage*/}
            {/*                    id="options.user.email"*/}
            {/*                    defaultMessage="Email"*/}
            {/*                />*/}
            {/*            </ListItemIcon>*/}
            {/*            <ListItemText*/}
            {/*                primary={user.email}*/}
            {/*            />*/}
            {/*        </ListItem>*/}
            {/*        {user.phone && <ListItem disableGutters={true}>*/}
            {/*            <ListItemIcon>*/}
            {/*                <FormattedMessage*/}
            {/*                    id="options.user.phone"*/}
            {/*                    defaultMessage="Phone"*/}
            {/*                />*/}
            {/*            </ListItemIcon>*/}
            {/*            <ListItemText*/}
            {/*                primary={user.phone}*/}
            {/*            />*/}
            {/*        </ListItem>}*/}
            {/*    </List>*/}
            {/*</CardContent>*/}
        </Card>
    );
}

export default SourceItem;